import React, { useState } from "react";
import { Button, Checkbox } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import TopTitleFormComponent from "./TopTitleFormComponent";
import { StandardDrawerFooter } from "./StandardDrawer";
import "./AdmissionDocumentRedesign.css";
import { updateDoc, doc as firestoreDoc, doc } from "firebase/firestore";
import { serverTimestamp, setDoc } from "firebase/firestore";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadString,
} from "firebase/storage";
import { db } from "../../firebase";
import { showCustomToast } from "../Misc/CustomToast";
import SignaturePadComponentV2 from "../Signature/SignaturePadComponentV2";

function AddAustralianSuperannuationForm(props) {
  //Tous les states des données récupérées par client

  const [checked1, setChecked1] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [checked3, setChecked3] = useState(false);
  const [signatureDataURL, setSignatureDataURL] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [, setIsSignatureStarted] = useState(false);

  const text1 =
    " I acknowledge that I am utilizing my superannuation funds to cover the costs of my treatment at Miracles Asia."
  const text2 =
    "I acknowledge that payment to Miracles Asia for the entire amount that has been requested through the Australian Taxation Office will be made when the funds have been made available in my nominated account."
  const text3 =
    "I acknowledge that failure to comply with the above terms will result in the termination of my treatment program at Miracles Asia. Additionally, the Australian Taxation Office will be informed that the released funds were not used for their approved purpose under their early access policies."

  const [isSignatureValidated, setIsSignatureValidated] = useState(false);

  const handleCheckboxChange1 = (event) => {
    setChecked1(event.target.checked);
  };

  const handleCheckboxChange2 = (event) => {
    setChecked2(event.target.checked);
  };

  const handleCheckboxChange3 = (event) => {
    setChecked3(event.target.checked);
  };

  const handleSignatureSave = (dataURL) => {
    setSignatureDataURL(dataURL);
  };

  const uploadSignature = async () => {
    const storage = getStorage();
    const fileName = `${clientId}.png`;
    const signatureRef = ref(
      storage,
      `MandatoryForms/Australiansuperannuation/${fileName}`
    );

    await uploadString(signatureRef, signatureDataURL, "data_url");
    const downloadURL = await getDownloadURL(signatureRef);

    return downloadURL;
  };

  const handleFormSubmit = async () => {
    if (
      !checked1 ||
      !checked2 ||
      !checked3 ||
      !signatureDataURL ||
      !isSignatureValidated
    ) {
      showCustomToast(
        "Please agree to all the terms before submitting.",
        "error"
      );
      return;
    }

    try {
      setIsLoading(true);
      const signatureURL = await uploadSignature();
      const docRef = doc(db, "AustralianSuperAnnuation", props.clientId);
      await setDoc(docRef, {
        checked1,
        checked2,
        checked3,
        text1,
        text2,
        text3,
        signatureURL,
        signedOn: serverTimestamp(),
      });

      const clientDocRef = firestoreDoc(db, "clients", props.clientId);
      await updateDoc(clientDocRef, {
        australianSuperannuationOk: true,
        australianSuperannuationDateSigned: serverTimestamp(),
      });

      showCustomToast(
        "Australian Superannuation form correctly submitted!",
        "success"
      );

      setIsLoading(false);
      props.closemodal();
    } catch (e) {
      showCustomToast("Error adding document", "error");

      console.error("Error adding document: ", e);
    }
  };

  const allChecked = checked1 && checked2 && checked3;

  const clientId = props.clientId;

  return (
    <>
      <div className="admission-document-shell admission-card-form-shell australian-superannuation-form-shell">
        <TopTitleFormComponent
          title="Australian superannuation form"
          eyebrow="Admission form"
          subtitle={`${props.firstName || "Client"} ${props.lastName || ""}`.trim()}
          closemodal={props.closemodal}
        />

        <div
          className="admission-document-body"
        >
          <div style={{ paddingLeft: "15px" }}>
            <div
              className="SubTitleBold"
              style={{ fontSize: "22px", marginBottom: "20px" }}
            >
              Acknowledgment Of Superannuation Payment Obligation
            </div>

            <div className="SubTitleBold">
              By signing this document you acknowledge that you understand and
              agree to the following points:
            </div>

            <div className="checkbox-container-margin-tris">
              <div className="block-text-check-bis">{text1}</div>
            </div>
            <div className="checkbox-container-margin-bis">
              <Checkbox checked={checked1} onChange={handleCheckboxChange1} />I
              fully understand and agree to the above terms.
            </div>

            <div className="checkbox-container-margin-tris">
              <div className="block-text-check-bis">{text2}</div>
            </div>
            <div className="checkbox-container-margin-bis">
              <Checkbox checked={checked2} onChange={handleCheckboxChange2} />I
              fully understand and agree to the above terms.
            </div>

            <div className="checkbox-container-margin-tris">
              <div className="block-text-check-bis">{text3}</div>
            </div>
            <div className="checkbox-container-margin-bis">
              <Checkbox checked={checked3} onChange={handleCheckboxChange3} />I
              fully understand and agree to the above terms.
            </div>
          </div>

          <div style={{ width: "100%", marginBottom: "25px" }}>
            <SignaturePadComponentV2
              onSignatureSave={handleSignatureSave}
              signatureDataURL={signatureDataURL}
              onSignatureStart={() => setIsSignatureStarted(true)}
              onSignatureValidate={setIsSignatureValidated}
            />
          </div>
        </div>

        <StandardDrawerFooter className="admission-document-footer">
          <div
            style={{
              marginBottom: "0px",
              display: "flex",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "flex-end",
              paddingRight: "0px",
              width: "100%",
              paddingTop: "10px",
            }}
          >
            <Button
              variant="contained"
              style={{ backgroundColor: "white", color: "black" }}
              // disabled={!(pic1Url && pic2Url && pic3Url && pic4Url && pic5Url)}
              onClick={props.closemodal}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleFormSubmit}
              style={
                isLoading
                  ? {
                      backgroundColor: "red",
                      color: "white",
                      marginLeft: "15px",
                    }
                  : !signatureDataURL || !isSignatureValidated || !allChecked
                  ? {
                      backgroundColor: "grey",
                      color: "white",
                      marginLeft: "15px",
                    }
                  : {
                      backgroundColor: "#1565C0",
                      color: "white",
                      marginLeft: "15px",
                    }
              }
              disabled={
                isLoading ||
                !signatureDataURL ||
                !allChecked ||
                !isSignatureValidated
              }

              //   onClick={handlePostRecord}
            >
              {isLoading ? "SAVING..." : "SAVE"}
            </Button>
          </div>
        </StandardDrawerFooter>
      </div>
    </>
  );
}

export default AddAustralianSuperannuationForm;
